import { BrowserRouter } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import { useEffect } from "react";
import Page from "../Page/Page.js";
import PoppingToastNotification from "../../Elements/Toast/PoppingToastNotification.js";
import ContentProvider from "../../../contexts/contentContext/contentContext.js";
import ModalProvider from "../../../contexts/modalContext/modalContext.js";
import CookieProvider from "../../../contexts/cookieContext/cookieContext.js";
import UserProvider from "../../../contexts/userContext/userContext.js";
import MarketingProvider from "../../../contexts/marketingContext/marketingContext.js";
import RecaptchaProvider from "../../../contexts/recaptchaContext/recaptchaContext.js";
import InputProvider from "../../../contexts/inputsContext/inputsContext.js";
import MailProvider from "../../../contexts/mailContext/mailContext.js";
import MailViewProvider from "../../../contexts/mailViewContext/mailViewContext.js";
import LightBoxProvider from "../../../contexts/lightBoxContext/lightBoxContext.js";
import CommentsProvider from "../../../contexts/commentsContext/commentsContext.js";
import SideBarProvider from "../../../contexts/sideBarContext/sideBarContext.js";
import ProfileProvider from "contexts/profileContext/profileContext.js";
import { Provider } from "react-redux";
import store from "../../../store/store.ts";
import PickerProvider from "contexts/pickerContext/pickerContext.ts";
import PersistGateWrapper from "./PersistGateWrapper.tsx";
import useCssVars from "hooks/useCssVars.ts";
import useRemoveOldPrefixFromPath from "hooks/useRemoveOldPrefixFromPath.ts";
import useRemoveSEOTagsCustomDomain from "hooks/useRemoveSEOTagsCustomDomain.ts";

import "../../../utils/_global.scss";
import "../../../utils/_column.scss";

/**
 * Providers getting access to data in all application
 */
function App() {
  useCssVars();
  useRemoveOldPrefixFromPath();
  useRemoveSEOTagsCustomDomain();

  return (
    <BrowserRouter basename="/">
      <Provider store={store}>
        <PersistGateWrapper>
          <ContentProvider>
            <CookieProvider>
              <UserProvider>
                <ToastProvider components={{ Toast: PoppingToastNotification }}>
                  <MarketingProvider>
                    <MailProvider>
                      <MailViewProvider>
                        <ModalProvider>
                          <InputProvider>
                            <RecaptchaProvider>
                              <LightBoxProvider>
                                <SideBarProvider>
                                  <CommentsProvider>
                                    <ProfileProvider>
                                      <PickerProvider>
                                        <Page />
                                      </PickerProvider>
                                    </ProfileProvider>
                                  </CommentsProvider>
                                </SideBarProvider>
                              </LightBoxProvider>
                            </RecaptchaProvider>
                          </InputProvider>
                        </ModalProvider>
                      </MailViewProvider>
                    </MailProvider>
                  </MarketingProvider>
                </ToastProvider>
              </UserProvider>
            </CookieProvider>
          </ContentProvider>
        </PersistGateWrapper>
      </Provider>
    </BrowserRouter>
  );
}

export default App;
